import { render, staticRenderFns } from "./TicketUpdate.vue?vue&type=template&id=5023165d"
import script from "./TicketUpdate.vue?vue&type=script&lang=js"
export * from "./TicketUpdate.vue?vue&type=script&lang=js"
import style0 from "./TicketUpdate.vue?vue&type=style&index=0&id=5023165d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports